import isNil from "lodash/isNil";
import qs from "query-string";

import { getDpr } from "./dpr";
import { IOptimizeImageConfig } from "./types";

// Test if given URL is a Shopify CDN url
export const isShopifyImageUrl = (url: string): boolean =>
  /cdn\.shopify\.com\//.test(url);

// Shopify's CDN has no `dpr` query param (unlike Fastly). To match Fastly's
// behavior where `width`/`height` are layout pixels and `dpr` scales output,
// we request layout dimensions multiplied by DPR in the URL.
const toShopifyPixelDimension = (
  layoutDimension: number,
  dpr: number
): string => Math.round(layoutDimension * dpr).toString();

export const getShopifyImageUrl = (
  imageUrl: string,
  options: IOptimizeImageConfig,
  isSSR: boolean
): string => {
  const [pathName, ...queries] = imageUrl.split("?");
  const params = qs.parse(queries.join("?"));
  const dpr = getDpr(options, isSSR);

  const layoutWidth =
    options.width && options.width > 0 ? options.width : undefined;
  const layoutHeight =
    options.height && options.height > 0 ? options.height : undefined;

  const isResizingOrCropping =
    !isNil(options.resizeMethod) || !isNil(options.crop);

  if (isResizingOrCropping) {
    if (layoutHeight) {
      params.height = toShopifyPixelDimension(layoutHeight, dpr);
    }
    if (layoutWidth) {
      params.width = toShopifyPixelDimension(layoutWidth, dpr);
    }
  } else if (layoutHeight) {
    params.height = toShopifyPixelDimension(layoutHeight, dpr);
  } else if (layoutWidth) {
    params.width = toShopifyPixelDimension(layoutWidth, dpr);
  }

  if (options.resizeMethod === "fill" && layoutWidth && layoutHeight) {
    params.crop = "center";
  }

  return `${pathName}?${qs.stringify(params, { encode: false })}`;
};
